import React, { ReactNode, SetStateAction, useState } from 'react';
import { ObjectMap, featureFlagContext } from './useFeatureFlagConfig';

type Props = {
  children: ReactNode;
};
export function FeatureFlagProvider(props: Readonly<Props>) {
  const { children } = props;
  const [featureFlagCache, setFeatureFlagCache] = useState<ObjectMap>({});

  const updateFeatureFlagCache = (newData: ObjectMap) => {
    setFeatureFlagCache((prevData: SetStateAction<ObjectMap>) => ({
      ...prevData,
      ...newData,
    }));
  };

  const { Provider } = featureFlagContext;
  return (
    <Provider value={{ featureFlagCache, updateFeatureFlagCache }}>
      {children}
    </Provider>
  );
}
